import { Component, Input, Output, OnInit, OnDestroy, DestroyRef, inject, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbModal, NgbModalConfig, NgbToastModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'app/modules/core.module';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormBuilder, Validators } from '@angular/forms';
import { InsuredService } from '@services/insured.service';
import { RutValidator, stringFormat } from 'app/validators/iatuch.validators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-information-personal',
  standalone: true,
  imports: [CoreModule, NgSelectComponent, NgbTooltipModule, NgbToastModule],
  providers: [InsuredService],
  templateUrl: './information-personal.component.html',
  styleUrls: ['./information-personal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationPersonalComponent {
  @Output() cancel = new EventEmitter<void>()
  @Output() saveInsured = new EventEmitter<any>()
  @Input() insuredId: string


  private _insuredService: InsuredService = inject(InsuredService)
  private fb: FormBuilder = inject(FormBuilder)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected showSpinner = true
  protected listGenders: [] = []
  protected minDate = new Date(1900, 0, 1).toISOString().split('T')[0]
  protected maxDate = new Date().toISOString().split('T')[0]


  public personalDataForm: any
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true
  })


  ngOnInit() {
    this.getGenders()
    if(this.insuredId) this.getInsuredById()

    this.personalDataForm = this.fb.group({
      rut: [null, [Validators.required]],
      dv: [null, [Validators.required]],
      names: [null, [Validators.required]],
      surname: [null, [Validators.required]],
      lastname: [null, [Validators.required]],
      genderId: [null, [Validators.required]],
      birthdate: [null, [Validators.required]],
      phone: [null, [Validators.required]],
      mail: [null, [Validators.required]]

    })


    this.showSpinner = false
  }

  setDigitVerificator() {
    const dv = RutValidator.setDigitVerificator(this.personalDataForm.value.rut)
    this.personalDataForm.patchValue({
      dv: dv
    })

    this.getInsuredByRut()
  }

  getInsuredById(){
    this._insuredService.getInsuredById(this.insuredId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.personalDataForm.patchValue({
        ...res,
        genderId: res.gender?._id || res.genderId,
        birthdate: res.birthdate.split('T')[0]
      })
    })
  }

  getInsuredByRut() {
    if (this.personalDataForm.value.rut != null) {
      this._insuredService.getInsuredByRut(this.personalDataForm.value.rut).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async res => {

        const data = res[0]
        if (data) {
          const result = await Swal.fire({
            title: 'Asegurado ya existe',
            text: `Ya existe un asegurado con RUT ${data.rut}-${data.dv} (${data.names} ${data.surname}). ¿Desea continuar con estos datos?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'Cancelar'
          })
          if (!result.isConfirmed) return
          this.saveInsured.emit({ _id: data._id })
          return
        }


      })
    }
  }

  getGenders() {
    this._insuredService.getGenders().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      this.listGenders = res
      this.personalDataForm.patchValue({ genderId: res._id })
      this.cdr.markForCheck()
    })
  }

  capitalize(controlName: String) {
    const control = this.personalDataForm.get(controlName);
    if (control) {
      stringFormat.capitalizeAll(control);
    }
  }

  save() {
    if (this.personalDataForm.valid) {
      this.saveInsured.emit(this.personalDataForm.value)
      this.personalDataForm.reset()
    } else {
      this.personalDataForm.markAllAsTouched()
      this.Toast.fire({
        title: "Confirmar los datos ingresados que esten correctos",
        icon: "info"
      })
    }

  }
}
